import domready from 'domready'
import PopupController from './controllers/popup-controller'

export default function initPopupControllers () {
  domready(() => {
    const popupElements = document.querySelectorAll('[data-popup-autoinit]')
    for (const element of popupElements) {
      // eslint-disable-next-line no-new
      element.popupController = new PopupController(element)
    }
  })
}
